import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useLegalClientSaveGlobalFinancialMonitoringPartOneMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { LegalClientSaveGlobalFinancialMonitoringPartOneParam } from 'api/types/params';

import { parseLegalClient } from './helpers';
import { parseLegalClientSaveGlobalFinancialMonitoringPartOneParam } from './helpers/parseLegalClientSaveGlobalFinancialMonitoringPartOneParam';

export const useLegalClientSaveGlobalFinancialMonitoringPartOne = () => {
  const [handle, { data, loading, error: apolloError }] =
    useLegalClientSaveGlobalFinancialMonitoringPartOneMutation();

  const error = useError(apolloError);

  return {
    data: data?.legalClient ? parseLegalClient(data.legalClient) : undefined,
    loading,
    error,
    saveFinancialMonitoring: useCallback(
      async (
        id: string,
        params: LegalClientSaveGlobalFinancialMonitoringPartOneParam
      ) => {
        const res = await handle({
          variables: {
            id,
            input:
              parseLegalClientSaveGlobalFinancialMonitoringPartOneParam(params),
          },
        });
        return res.data?.legalClient
          ? parseLegalClient(res.data.legalClient)
          : undefined;
      },
      [handle]
    ),
  };
};
